import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-f50cfd0c"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "promotion"
};

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "header flex"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "item"
}, "用户名"), /*#__PURE__*/_createElementVNode("div", {
  class: "item"
}, "推广级别"), /*#__PURE__*/_createElementVNode("div", {
  class: "item"
}, "加入时间")], -1));

const _hoisted_3 = {
  key: 0,
  class: "tbody"
};
const _hoisted_4 = {
  class: "item"
};
const _hoisted_5 = {
  class: "item"
};
const _hoisted_6 = {
  class: "item"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_list = _resolveComponent("van-list");

  const _component_no_data = _resolveComponent("no-data");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, $setup.inviteLogList.length ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_component_van_list, {
    loading: $setup.loading,
    "onUpdate:loading": _cache[0] || (_cache[0] = $event => $setup.loading = $event),
    error: $setup.error,
    "onUpdate:error": _cache[1] || (_cache[1] = $event => $setup.error = $event),
    finished: $setup.finished,
    offset: 20,
    "error-text": "请求失败，点击重新加载",
    "finished-text": "-我也是有底线的-",
    "loading-text": "正在获取数据...",
    onLoad: $setup.onLoad
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.inviteLogList, (item, index) => {
      return _openBlock(), _createElementBlock("div", {
        class: "flex",
        key: index
      }, [_createElementVNode("div", _hoisted_4, _toDisplayString(item.username), 1), _createElementVNode("div", _hoisted_5, _toDisplayString(item.level), 1), _createElementVNode("div", _hoisted_6, _toDisplayString($setup.getMyDate(item.created, 2)), 1)]);
    }), 128))]),
    _: 1
  }, 8, ["loading", "error", "finished", "onLoad"])])) : (_openBlock(), _createBlock(_component_no_data, {
    key: 1
  }))]);
}